<template>
  <slot></slot>
</template>

<script>
import backend from "@/components/waffle/backend";

export default {
  name: 'ErrorBoundary',
  emits: ['generic-error'],
  props:['errorContent'],
  methods: {
    async getGenericPopUp() {
      try
      {
        const response = await backend.getData('error')
        this.$emit('generic-error', response )
      } catch (e) {
        console.warn(e)
        //todo: add fallback if backend is completely down
        this.$emit('generic-error', {
          data:{
            content:this.errorContent,
            fields:[],
            listings:null
          }
        })
      }
    }
  },
  errorCaptured(err) {
    console.warn(err)
    this.getGenericPopUp()
  },
}
</script>
